var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.303,
    cx: 10,
    cy: 10,
    r: 9.302
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#66818D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.484 4.484 0 10 0s10 4.484 10 10-4.484 10-10 10S0 15.516 0 10zm1.395 0c0 4.744 3.86 8.605 8.605 8.605 4.744 0 8.605-3.86 8.605-8.605 0-4.744-3.86-8.605-8.605-8.605-4.744 0-8.605 3.86-8.605 8.605z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.674 10.698A.703.703 0 0 1 6.977 10c0-.381.316-.698.697-.698h5.582c.381 0 .697.317.697.698a.703.703 0 0 1-.697.698H7.674z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.041 13.284-2.79-2.791a.702.702 0 0 1 0-.986l2.79-2.79c.27-.27.717-.27.986 0 .27.269.27.716 0 .985L7.73 10l2.297 2.298c.27.27.27.716 0 .986a.69.69 0 0 1-.493.204.69.69 0 0 1-.493-.204z",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse2);
export default __webpack_public_path__ + "static/media/collapse_2.e787f3db3f31a91a3aa5377e6656ffa1.svg";
export { ForwardRef as ReactComponent };